/**
 * @generated SignedSource<<5afd6f3ce6057740939ba637ace86d18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoicePrints_voicePrint$data = {
  readonly audioFileUrl: string;
  readonly createdAt: string;
  readonly id: string;
  readonly sourceMeetingRecording: {
    readonly title: string;
    readonly url: string | null;
  } | null;
  readonly sourceStart: number;
  readonly " $fragmentType": "VoicePrints_voicePrint";
};
export type VoicePrints_voicePrint$key = {
  readonly " $data"?: VoicePrints_voicePrint$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoicePrints_voicePrint">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoicePrints_voicePrint",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "audioFileUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "sourceMeetingRecording",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceStart",
      "storageKey": null
    }
  ],
  "type": "VoicePrint",
  "abstractKey": null
};

(node as any).hash = "51411a7b2cebae48aae6f2e455f20b47";

export default node;
